import React, {useEffect, useState} from 'react'
import {connect, useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {logEvent} from '../../Utils/utils'
import {_formatPrice} from '../../Utils/tools'
import {pharmacyChainUrl} from '../../Utils/constants'
import loadingYapp from '../../assets/img/yapp_loading.gif'
import proIconLoading from '../../assets/img/proIconLoading.svg'
import ModalRecemed from '../../Components/Modals/ModalRecemed'
import ModalSendPrices from '../../Components/Modals/ModalSendPrices'
import SubscriptionCard from '../../Components/Card/SubscriptionCard'
import {
  getBioequivalents,
  getProductPricesById,
  getSubscriptionInfoByProductId,
  getGenerateLink,
  sendMail,
} from '../../Utils/api'
import ModalDiscountSendModal from '../../Components/Modals/ModalDiscountSendEmail'
import Toasts from '../../Components/Toasts/Toasts'
import ButtonYapp from '../../Components/Buttons/ButtonYapp'
import QuotationPDF from '../../Components/PDF/QuotationPDF'
import {pdf} from '@react-pdf/renderer'

function PriceFinderDetail(props) {
  const history = useHistory()
  const subscriptionProProduct = useSelector(
    (state) => state.app.subscriptionProProduct,
  )

  const [quotation, setQuotation] = useState(null)

  const [loading, setLoading] = useState(true)
  const [pharmacyPrices, setPharmacyPrices] = useState()
  const [bio, setBio] = useState(null)
  const [modalRecemed, setModalRecemed] = useState(false)
  const [subscriptionInfo, setSubscriptionInfo] = useState(null)
  const [modalSendPricesState, setModalSendPricesState] = useState(false)

  const [sendDiscountIsOpen, setSendDiscountIsOpen] = useState(false)
  const isProHash = useSelector((state) => state.app.isPro)
  const [stateToasts, setStateToasts] = useState(false)
  const [appState, setAppState] = useState({loading: false, data: null})

  useEffect(async () => {
    try {
      setLoading(true)
      setQuotation(null)
      if (props?.results?.product_id) {
        getPharmaciesByProductId(props?.results?.product_id)
      } else {
        history.push('/error')
      }

      getBioequivalentsProducts(props?.results?.product_id)
      getSubscriptionInfo()
    } catch (ignore) {}
  }, [props?.results])

  const getSubscriptionInfo = async () => {
    let professionalDiscount =
      props.professionalDiscountCode?.products?.length > 0
        ? props.professionalDiscountCode.products.filter(
            (product) => product.product_id === props?.results?.product_id,
          )
        : []
    let subscriptionInfo = null

    try {
      let subscriptionResponse = await getSubscriptionInfoByProductId(
        props?.results?.product_id,
      )

      if (subscriptionResponse?.data?.length > 0) {
        subscriptionInfo = subscriptionResponse.data[0]
        subscriptionInfo.prices = JSON.parse(subscriptionInfo.prices)
        subscriptionInfo.program_price = JSON.parse(
          subscriptionInfo.program_price,
        )
        subscriptionInfo.delivery = []
        subscriptionInfo.product = props?.results?.product
        subscriptionInfo.product.counter = 1

        subscriptionInfo.summary_title = subscriptionProProduct.summaryTitle
        subscriptionInfo.summary_text = subscriptionProProduct.summaryText

        if (subscriptionInfo.program_price.length > 0) {
          subscriptionInfo.program_price.sort(
            (a, b) => parseFloat(a.priority) - parseFloat(b.priority),
          )
        }

        if (
          professionalDiscount.length > 0 &&
          professionalDiscount[0].discount_value
        ) {
          subscriptionInfo.professional_discount =
            professionalDiscount[0].discount_value
          subscriptionInfo.professional_discount_code =
            props.professionalDiscountCode.code
          subscriptionInfo.professional_discount_price =
            (1 - professionalDiscount[0].discount_value / 100) *
            subscriptionInfo.min_price
          subscriptionInfo.share_button_text = subscriptionProProduct.btnText
        }
      }
    } catch (e) {}
    setSubscriptionInfo(subscriptionInfo)
  }

  const getPharmaciesByProductId = async (productId) => {
    let result = await getProductPricesById(productId)
    if (result?.data?.prices) {
      setPharmacyPrices(result.data.prices)
    }
    setLoading(false)
  }

  // Array Card Interaction

  function copyCodeToClipboard() {
    logEvent('Item Copied', {
      'Item Type': 'Yapp Benefit Code',
      'Element Copied': props.professionalDiscountCode.code,
    })
    const tempInput = document.createElement('input')
    tempInput.value = props.professionalDiscountCode.code
    document.body.appendChild(tempInput)
    tempInput.select()
    document.execCommand('copy')
    document.body.removeChild(tempInput)
    setStateToasts(true)
  }

  const getBioequivalentsProducts = async (dataProductId) => {
    try {
      let bioProducts = await getBioequivalents(dataProductId)
      if (bioProducts?.data) {
        setBio(bioProducts?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function showQuotation(isPDF, email) {
    setLoading(true)
    try {
      let blobURL = null
      let responseLink = quotation?.responseLink
      if (!quotation?.responseLink) {
        responseLink = await getGenerateLink([
          {
            quantity: 1,
            id: props?.results?.product_id,
          },
        ])
        if (responseLink?.message === 'OK: Success') {
          responseLink = responseLink?.data?.url
          setQuotation({...quotation, responseLink: responseLink})
        }
      }
      if (quotation?.blobURL && isPDF) {
        window.open(quotation.blobURL)
        return
      }
      if (isPDF) {
        const blob = await pdf(
          <QuotationPDF
            pharmacyPrices={pharmacyPrices}
            product={props?.results?.product}
            link={responseLink}
          />,
        ).toBlob()

        blobURL = URL.createObjectURL(blob)

        setQuotation({
          responseLink: responseLink,
          blobURL: blobURL,
        })

        window.open(blobURL)
      } else {
        setModalSendPricesState(false)
        let productData = props?.results?.product
        await sendMail(
          email,
          'cotiza@yapp.cl',
          '',
          'd-c992f024f9fd449090e9dfe2fe83370c',
          {
            quotation_url: responseLink,
            products: [
              {
                product_name: productData?.product_name,
                product_img: productData?.product_logo,
                formula_name: productData?.formula_name,
                presentation: productData?.presentation,
                laboratory_name: productData?.laboratory_name,
                quotation: pharmacyPrices.map((c) => ({
                  pharmacy_name: c.pharmacyChainName,
                  pharmacy_logo: pharmacyChainUrl + c.pharmacyChainLogo,
                  list_price: _formatPrice(c.listPrice),
                  fractional_price: _formatPrice(c.fractionalPrice),
                })),
              },
            ],
          },
        )
      }
    } catch (ignore) {
    } finally {
      setLoading(false)
      setModalSendPricesState(false)
    }
  }
  return (
    <>
      <div className="flex-grow-1 px-3">
        <div>
          {loading ? (
            <div className="text-center image-center">
              <h2 className="title-primary--3xl-bold mt-3">
                En breve verás tu búsqueda
              </h2>
              <img
                src={loadingYapp}
                alt="loading"
                className="loading-yapp--pro m-0"
              />
              <img
                src={proIconLoading}
                alt="Loading icon"
                className="maxw-290"
              />
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between mt-2 mb-4">
                {pharmacyPrices?.length > 0 && (
                  <>
                    <ButtonYapp
                      className="w-50  m-1 font--14"
                      disabled={false}
                      title={'Enviar por correo'}
                      color={'--color-primary'}
                      onClick={() => setModalSendPricesState(true)}
                      
                    />
                    <ButtonYapp
                      className="w-50  m-1 font--14"
                      disabled={false}
                      title={'Imprimir'}
                      stroke={true}
                      color={'--color-primary'}
                      onClick={() => showQuotation(true)}
                      
                    />
                  </>
                )}
              </div>
              <div className="mb-4 mt-4">
                {isProHash && subscriptionInfo && (
                  <div>
                    <div className="d-flex justify-content-between py-3">
                      <div>
                        <h4 className="txt-2--bold-db mb-3">
                          Opciones para tus pacientes
                        </h4>
                        <h4 className="title-primary--xl-bold line-14 my-3">
                          Tratamiento con Convenio Yapp
                        </h4>
                      </div>
                    </div>
                    <div className="content-quotetation">
                      <div className="content-quotetation--item">
                        <div className="content-pharmacies">
                          <SubscriptionCard
                            index={1}
                            data={subscriptionInfo}
                            sendDataSubscription={null}
                            isProfessional={true}
                            totalProducts={1}
                            setSendDiscountIsOpen={setSendDiscountIsOpen}
                          />

                          <ModalDiscountSendModal
                            closeDiscountModal={() =>
                              setSendDiscountIsOpen(false)
                            }
                            sendMailIsOpen={sendDiscountIsOpen}
                            discountCode={props.professionalDiscountCode}
                            userInfo={props.userInfo}
                            product={appState?.data}
                            discount={subscriptionInfo.professional_discount}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {pharmacyPrices?.length > 0 && (
                  <h4 className="title-primary--xl-bold line-14 mt-3 mb-1">
                    Precios en farmacias
                  </h4>
                )}
                <div className="content-card-result-pharmacy px-0">
                  {pharmacyPrices?.length > 0 ? (
                    pharmacyPrices?.map((item, key) => (
                      <div key={key} className="card-result-pharmacy">
                        <div className="header-card-result-pharmacy">
                          <img
                            src={
                              process.env
                                .REACT_APP_REPO_IMG_PHARM_LOGO_SERV_URL +
                              item.pharmacyChainLogo
                            }
                            alt="pharmacy"
                            className="card-result-pharmacy-img"
                          />
                          <h4 className="title-primary ml-2">
                            {item.pharmacyChainName}
                          </h4>
                        </div>
                        <div className="content-card-result-pharmacy">
                          <div className="d-flex justify-content-between align-items-center mb-1 w-100">
                            <p className="txt-4--bold">Precio lista</p>
                            <p className="txt-4--bold text-right">
                              {_formatPrice(item.listPrice)}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="txt-5--regular color-gray-4">
                              Precio fraccionado
                            </p>
                            <p className="txt-5--regular color-gray-4 text-right">
                              {_formatPrice(item.fractionalPrice)}{' '}
                              {item.typeFractionation}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <p className="color-gray-4 text-center">
                        No hay resultados disponibles 😢
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <ModalSendPrices
        modalSendPricesState={modalSendPricesState}
        setModalSendPricesState={setModalSendPricesState}
        onClickButton={(email) => showQuotation(false, email)}
      />
      <ModalRecemed isOpen={modalRecemed} setIsOpen={setModalRecemed} />
      <Toasts
        text="Código copiado"
        timer="5000"
        icon="icon-check"
        stateToasts={stateToasts}
        setStateToasts={setStateToasts}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    professionalDiscountCode: state.user.professional_discount_code,
    userInfo: state.user.userInfo,
  }
}

export default connect(mapStateToProps)(PriceFinderDetail)
